import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { HttpApiClient } from "../../axios/axiosInstance";
import {
  createJobService,
  removeJobSerivce,
  getJobsService,
  submitJobProposalService,
  removeJobProposalService,
  getJobProposalService,
  acceptProposalService,
  selfProposalService,
} from "../../services";

const initialState = {
  jobs: [],
  jobsLoading: false,
  jobsError: null,
  totalJobs: null,
  jobProposals: [],
  jobProposalsLoading: false,
  jobProposalsError: null,
  createJobLoading: false,
  createJobError: null,
  removeJobLoading: false,
  removeJobError: null,
  submitProposalSuccess: false,
  submitProposalLoading: false,
  submitProposalError: null,
  removeProposalLoading: false,
  removeProposalError: null,
  propposalAccepted: false,
  acceptProposalLoading: false,
  acceptProposalError: null,
  selfProposals: [],
  selfProposalLoading: false,
  selfProposalError: null,
  selfTotalProposals: null
};

export const createJob = createAsyncThunk("job/createJob", async (request) => {
  const response = await HttpApiClient.post(createJobService, request);
  return response.data;
});

export const removeJob = createAsyncThunk("job/removeJob", async (request) => {
  const response = await HttpApiClient.post(removeJobSerivce, request);
  return response.data;
});

export const getJobs = createAsyncThunk("job/getJobs", async (request) => {
  console.log("job api call")
  const response = await HttpApiClient.post(getJobsService, request);
  return response.data;
});

export const getSelfProposal = createAsyncThunk(
  "proposal/createSelfProposal",
  async (request) => {

    const response = await HttpApiClient.post(selfProposalService, request);
    return response.data;

  }
);

export const submitJobProposal = createAsyncThunk(
  "job/submitJobProposal",
  async (request) => {
    const response = await HttpApiClient.post(
      submitJobProposalService,
      request
    );
    return response.data;
  }
);
export const acceptProposal = createAsyncThunk("job/acceptProposal",
  async (request) => {
    const response = await HttpApiClient.post(
      acceptProposalService,
      request
    );
    return response.data;
  })

export const removeJobProposal = createAsyncThunk(
  "job/removeJobProposal",
  async (request) => {
    const response = await HttpApiClient.post(
      removeJobProposalService,
      request
    );
    return response.data;
  }
);

export const getJobProposals = createAsyncThunk(
  "job/getJobProposals",
  async (request) => {
    const response = await HttpApiClient.post(getJobProposalService, request);
    return response.data;
  }
);

const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    clearJobErrors: (state) => {
      state.jobsError = null;
      state.createJobError = null;
      state.removeJobError = null;
      state.jobProposalsError = null;
      state.submitProposalError = null;
      state.removeProposalError = null;
      state.artistError = null;
    },
    resetJobState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Create Job

      .addCase(getSelfProposal.pending, (state) => {
        state.selfProposalLoading = true;
        state.selfProposalError = null;
        state.selfTotalProposals = null;
      })
      .addCase(getSelfProposal.fulfilled, (state, action) => {
        state.selfProposalLoading = false;
        state.selfProposalError = null;
        state.selfProposals = (action.payload.data.data) || []; // or replace if needed
        state.selfTotalProposals = action.payload.data.total || 0
      })
      .addCase(getSelfProposal.rejected, (state, action) => {
        state.selfProposalLoading = false;
        state.selfProposalError = action.payload || 'Failed to create self proposal';
        state.selfTotalProposals = null;
      })
      .addCase(acceptProposal.pending, (state) => {
        state.acceptProposalLoading = true;
        state.acceptProposalError = null;
      })
      .addCase(acceptProposal.fulfilled, (state, action) => {
        state.acceptProposalLoading = false;
        state.acceptProposalError = null;
        state.propposalAccepted = true
      })
      .addCase(acceptProposal.rejected, (state, action) => {
        state.acceptProposalLoading = false;
        state.acceptProposalError = action.error?.message || 'Something went wrong';
        state.acceptProposalSuccess = false;
      })

      .addCase(createJob.pending, (state) => {
        state.createJobLoading = true;
        state.createJobError = null;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.createJobLoading = false;
        if (action.payload.data) {
          state.jobs = [action.payload.data, ...state.jobs];
        }
      })
      .addCase(createJob.rejected, (state, action) => {
        state.createJobLoading = false;
        state.createJobError = action.error.message;
      })

      // Remove Job
      .addCase(removeJob.pending, (state) => {
        state.removeJobLoading = true;
        state.removeJobError = null;
      })
      .addCase(removeJob.fulfilled, (state, action) => {
        state.removeJobLoading = false;
        if (action.payload.data && action.payload.data.id) {
          state.jobs = state.jobs.filter(
            (job) => job.id !== action.payload.data.id
          );
        }
      })
      .addCase(removeJob.rejected, (state, action) => {
        state.removeJobLoading = false;
        state.removeJobError = action.error.message;
      })

      // Get Jobs
      .addCase(getJobs.pending, (state) => {
        state.jobsLoading = true;
        state.jobsError = null;
        state.totalJobs = null;
        state.submitProposalError = null;
        state.submitProposalSuccess = false;
      })
      .addCase(getJobs.fulfilled, (state, action) => {
        state.jobsLoading = false;
        state.jobs = action?.payload?.data?.results || [];
        state.totalJobs = action?.payload?.data?.total || []
      })
      .addCase(getJobs.rejected, (state, action) => {
        state.jobsLoading = false;
        state.jobsError = action.error.message;
        state.totalJobs = null;
      })

      // Submit Job Proposal
      .addCase(submitJobProposal.pending, (state) => {
        state.submitProposalLoading = true;
        state.submitProposalError = null;
      })
      .addCase(submitJobProposal.fulfilled, (state, action) => {
        state.submitProposalLoading = false;
        state.submitProposalSuccess = true;

      })
      .addCase(submitJobProposal.rejected, (state, action) => {
        state.submitProposalLoading = false;
        state.submitProposalError = action.error.message;
        state.submitProposalSuccess = false;
      })

      // Remove Job Proposal
      .addCase(removeJobProposal.pending, (state) => {
        state.removeProposalLoading = true;
        state.removeProposalError = null;
      })
      .addCase(removeJobProposal.fulfilled, (state, action) => {
        state.removeProposalLoading = false;
        if (action.payload.data && action.payload.data.id) {
          state.jobProposals = state.jobProposals.filter(
            (proposal) => proposal.id !== action.payload.data.id
          );
        }
      })
      .addCase(removeJobProposal.rejected, (state, action) => {
        state.removeProposalLoading = false;
        state.removeProposalError = action.error.message;
      })

      // Get Job Proposals
      .addCase(getJobProposals.pending, (state) => {
        state.jobProposalsLoading = true;
        state.jobProposalsError = null;
      })
      .addCase(getJobProposals.fulfilled, (state, action) => {
        state.jobProposalsLoading = false;
        state.jobProposals = action.payload.data?.data || [];
      })
      .addCase(getJobProposals.rejected, (state, action) => {
        state.jobProposalsLoading = false;
        state.jobProposalsError = action.error.message;
      });
  },
});

export const { clearJobErrors, resetJobState } = jobSlice.actions;
export default jobSlice.reducer;
